import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
  type DragEndEvent,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import React, { useContext } from "react";
import TableContext, { TableContextProvider } from "../context/TableContext";

export interface TableProps {
  headerList?: any[];
  tableStrip?: true | false;
  className?: string;
  action?: any;
  children?: any;
  draggable?: boolean;
  onDrag?: (event: any[]) => void;
  tablebodyList?: [];
}

const RazorTable: React.FC<TableProps> = ({
  headerList,
  tableStrip,
  className,
  action,
  children,
  draggable,
  onDrag,
  tablebodyList,
}) => {
  const tableCtx = useContext(TableContext);

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = tablebodyList?.findIndex(
        (item: any) => item.id === active.id
      ) as any;
      const newIndex = tablebodyList?.findIndex(
        (item: any) => item.id === over?.id
      ) as any;
      const newList =
        tablebodyList && tablebodyList.length > 0
          ? arrayMove(tablebodyList, oldIndex, newIndex)
          : [];
      onDrag && onDrag(newList);
    }
  };

  return (
    <>
      {draggable ? (
        <>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={
                tablebodyList &&
                (tablebodyList.map((item: any) => item.id) as any)
              }
              strategy={verticalListSortingStrategy}
            >
              <TableContextProvider>
                <table
                  className={`table ${
                    tableStrip && "table_strip"
                  } ${className} `}
                >
                  {/* table head start */}
                  <thead className="table-head">
                    <tr
                      onClick={() => {
                        tableCtx?.setShowDropActive("");
                      }}
                    >
                      <th style={{ width: "5rem", paddingRight: "2rem" }}></th>
                      {headerList &&
                        headerList.map((chi, idx) => {
                          const { label } = chi;
                          return <th key={idx}>{label || chi}</th>;
                        })}
                      {action && <th className="action">ACTION(S)</th>}
                    </tr>
                  </thead>
                  {/* table head end */}
                  {/* table body start */}
                  <tbody className="table-body">{children}</tbody>
                  {/* table body end */}
                </table>
              </TableContextProvider>
            </SortableContext>
          </DndContext>
        </>
      ) : (
        <>
          <TableContextProvider>
            <table
              className={`table ${tableStrip && "table_strip"} ${className} `}
            >
              {/* table head start */}
              <thead className="table-head">
                <tr
                  onClick={() => {
                    tableCtx?.setShowDropActive("");
                  }}
                >
                  {headerList &&
                    headerList.map((chi, idx) => {
                      const { label } = chi;
                      return <th key={idx}>{label || chi}</th>;
                    })}
                  {action && <th className="action">ACTION(S)</th>}
                </tr>
              </thead>
              {/* table head end */}
              {/* table body start */}
              <tbody className="table-body">{children}</tbody>
              {/* table body end */}
            </table>
          </TableContextProvider>
        </>
      )}
    </>
  );
};

export default RazorTable;
